import i18next from 'i18next';
import IMask from 'imask';

import { EntityOptionData } from 'api/EntityOptions/interfaces';
import { Option } from 'app/components/FormControl/interfaces';
import { OptionRadioModel } from 'app/SharedComponents/OptionWithRadioButton/interfaces';

export const transformEntityToOptions = (entities: EntityOptionData[]) => {
  let transformedData: Option[] = [];
  if (entities.length === 0) return [];
  entities.forEach(entity =>
    transformedData.push({
      key: entity.name,
      value: entity.code,
    }),
  );

  return transformedData;
};

export const transformEntityToOptionsWithTranslation = (
  entities: EntityOptionData[],
  keyPrefix?: string,
) => {
  const { t } = i18next;
  let transformedData: Option[] = [];
  if (entities.length === 0) return [];
  entities.forEach(entity =>
    transformedData.push({
      key: keyPrefix ? t(`${keyPrefix}.${entity.name}`) : t(`${entity.name}`),
      value: entity.code,
    }),
  );

  return transformedData;
};

export const transformToIDR = (value: number) => {
  const currencyMask = IMask.createMask({
    mask: Number,
    thousandsSeparator: '.',
  });

  currencyMask.resolve(`${value}`);

  return currencyMask.value;
};

export const transformToNumber = (
  value: string | boolean | number | undefined | null,
): number => {
  if (value === undefined || value === null || value === '') return 0;
  return Number(value);
};

export const transformLicenseNumber = (value: string) => {
  const licenseNumberMask = IMask.createMask({
    mask: 'a[a] 0[000] a[aa]',
  });

  licenseNumberMask.resolve(value);
  return licenseNumberMask.value;
};

export const transformStringToOptionsRadio = (entities: string[]) => {
  let transformedData: OptionRadioModel[] = [];
  if (entities.length === 0) return [];
  entities.forEach(entity =>
    transformedData.push({
      name: entity,
      value: entity,
    }),
  );

  return transformedData;
};

export const capitalize = (val: string) => {
  const str = val.toLowerCase();
  return str.replace(/\b\w/g, l => l.toUpperCase());
};
